const LABELS = {
    hpAt60: "hp @ 60 Hz",
    hpAt: "hp @ ",
    TotalPowerRequired: "Total power required",
    MotorSeries: "Motor series",
    ShowAllMotors: "Show all motors",
    Auto: "Auto",
    Efficiency: "Efficiency",
    MotorLoadNP: "Motor load (NP)",
    OperatingTemp: "Operating temp",
    Current: "Current",
    Voltage: "Voltage",
    PowerFfactor: "Power factor",
    kw: "kW",
    Speed: "Speed RPM",
    Power: "Power hp",
    MotorRating: "Motor rating",
    hp: "HP",
    volts: "Volts",
    amps: "Amps",
    Rating: "Rating (%)",
    PerformacePlot: "Performance plot:",
    FluidVelocityPostMotor: "Fluid velocity past motor",
    ShroudWeight: "Shroud weight",
    ShroudOd: "Shroud OD",
    SelectSensor: "Select sensor",
    StartupFreq: "Startup frequency",
    MinFrequencyDeparture: "Min frequency at departure",
    MaxFrequency: "Max frequency",
    ftPerSec: "ft/sec"
};

export default LABELS;
